import React from 'react'

import partners_bg from '../../../assets/ww.png'
import netflix from '../../../assets/netflix.png'
import showtime from '../../../assets/showtime.png'
import mnet_movies from '../../../assets/mnet-movies.png'
import fox from '../../../assets/fox.png'
import tv from '../../../assets/tv.png'

const HomePartners = () => {
	const partners = [
		{
			id: 1,
			image: netflix,
			style: '',
		},
		{
			id: 2,
			image: showtime,
			style: '',
		},
		{
			id: 3,
			image: mnet_movies,
			style: '',
		},
		{
			id: 4,
			image: fox,
			style: '',
		},
		{
			id: 5,
			image: tv,
			style: 'last',
		},
	]

	return (
		<section
			className='homepage_partners'
			style={{ background: `url(${partners_bg})` }}
		>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12 text-center'>
						<h3 className='section_header'>Our Partners</h3>
					</div>

					{partners.map((part) => (
						<div key={part.id} className='col text-center'>
							<img src={part.image} alt='' className={part.style} />
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

export default HomePartners
